import { render, staticRenderFns } from "./ManageTeamPortfolioModalWrapper.vue?vue&type=template&id=5766ea05"
import script from "./ManageTeamPortfolioModalWrapper.vue?vue&type=script&lang=js"
export * from "./ManageTeamPortfolioModalWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports